module.exports = __webpack_public_path__ + "media/customizations/trinityfalls/logo-a20b4e8f4d46b073d6cbcb43574f1afb.png";